const Clipboard = {
  setString: (text: string) => {
    navigator.clipboard.writeText(text).catch(() => {});
  },
  getString: async () => {
    try {
      return await navigator.clipboard.readText();
    } catch {
      return '';
    }
  },
};

export default Clipboard;
